document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.cards-scroller').forEach((scroller) => {
    scroller.addEventListener('scroll', () => {
      const isAtEnd =
        scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth;
      scroller.style.setProperty(
        '--card-scroller-can-scroll-right',
        isAtEnd ? '0' : '1'
      );
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  let scrollerPositions = {};

  document
    .querySelectorAll(
      '[data-action="scrollerNext"], [data-action="scrollerPrev"]'
    )
    .forEach((el) => {
      el.addEventListener('click', () => {
        const id = el.getAttribute('data-controls');
        const action = el.getAttribute('data-action');
        const slider = document.getElementById(id);
        const slides = slider.querySelectorAll('.card');
        const slidesCount = slides.length;
        const sliderWidth = slider.getBoundingClientRect().width;
        let currentSlide = 0;

        // get all slide positions
        if (typeof scrollerPositions[id] === 'undefined') {
          scrollerPositions[id] = [];
          slider.querySelectorAll('.card').forEach((item) => {
            scrollerPositions[id].push(
              Math.round(item.getBoundingClientRect().left)
            );
          });
        }

        // compare the scroll position to the slide position
        for (i = scrollerPositions[id].length - 1; i >= 0; i--) {
          if (
            scrollerPositions[id][i] >=
            parseFloat(slider.getAttribute('data-scrollLeft'))
          ) {
            currentSlide = i;
          }
        }

        // next or prev slider
        if (action === 'scrollerNext') {
          currentSlide++;
          if (currentSlide >= slidesCount) {
            currentSlide = 0;
          }
        } else {
          currentSlide--;
          if (currentSlide < 0) {
            currentSlide = slidesCount - 1;
          }
        }

        // scroll to the new current slider
        const item = slides[currentSlide];
        slider.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
        return false;
      });
    });

  // update the scroll position on each slider so it's easy to access
  document.querySelectorAll('.cards-scroller').forEach((el) => {
    el.setAttribute('data-scrollLeft', 0);

    el.addEventListener(
      'scroll',
      (event) => {
        el.setAttribute('data-scrollLeft', el.scrollLeft);

        const id = el.getAttribute('id');

        // Hide or show nav buttons based on scroll position
        const nextBtn = document.querySelector(
          `[data-controls="${id}"][data-action="scrollerNext"]`
        );
        const prevBtn = document.querySelector(
          `[data-controls="${id}"][data-action="scrollerPrev"]`
        );

        const isAtStart = el.scrollLeft <= 0;
        const isAtEnd =
          Math.ceil(el.scrollLeft + el.clientWidth) >= el.scrollWidth;

        if (nextBtn) nextBtn.disabled = isAtEnd;
        if (prevBtn) prevBtn.disabled = isAtStart;
      },
      { passive: true }
    );
  });

  window.addEventListener('resize', function (e) {
    scrollerPositions = {};
  });
});

// Show .cards-scroll__controls only when there is horizontal overflow
// and the device is NOT touch-capable. Run on load and on resize.
(function () {
  const scroller = document.querySelector('.cards-scroller');
  const controls = document.querySelector('.cards-scroller__controls');
  if (!scroller || !controls) return;

  const isTouch = () =>
    'ontouchstart' in window ||
    (navigator.maxTouchPoints || 0) > 0 ||
    (navigator.msMaxTouchPoints || 0) > 0;

  const hasOverflowX = () => scroller.scrollWidth - scroller.clientWidth > 1;

  const updateControlsVisibility = () => {
    const show = hasOverflowX() && !isTouch();
    controls.style.display = show ? '' : 'none';
  };

  // Initial check + after all assets load (images can change width)
  updateControlsVisibility();
  document.addEventListener('load', updateControlsVisibility);
  window.addEventListener('resize', updateControlsVisibility);
})();
